import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import api from '../../services/api';

const TipoArquivoLabel = {
    1: 'protocolos',
    2: 'fluxogramas',
    3: 'diretrizes',
    4: 'documentos',
    5: 'videos',
    6: 'outros',
    7: 'links',
};

function getYoutubeEmbedUrl(url) {
    const regExp = /(?:youtube\.com\/(?:watch\?v=|embed\/|live\/|v\/|shorts\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
    const match = url.match(regExp);
    return match?.[1] ? `https://www.youtube.com/embed/${match[1]}` : null;
}

const VisualizadorArquivo = () => {
    const { arquivoID } = useParams();
    const [arquivo, setArquivo] = useState(null);
    const [erro, setErro] = useState(false);

    useEffect(() => {
        const buscaArquivo = async () => {
            try {
                const response = await api.get(`/arquivos/${arquivoID}`);
                setArquivo(response.data);
                setErro(false);
            } catch (error) {
                console.error("Erro ao buscar o arquivo:", error);
                setErro(true);
            }
        };

        buscaArquivo();
    }, [arquivoID]);

    if (erro) return <p style={{ color: 'red', textAlign: 'center' }}>Erro ao carregar o arquivo.</p>;
    if (!arquivo) return <p style={{ textAlign: 'center' }}>Carregando arquivo...</p>;

    const subpasta = TipoArquivoLabel[arquivo.tipo] || 'outros';
    const isPDF = arquivo.hashArquivo.toLowerCase().endsWith('.pdf');
    const baseURL =
        process.env.NODE_ENV === 'development'
            ? 'http://localhost:8008/uploads'
            : process.env.REACT_APP_UPLOADS_URL;

    const containerStyle = {
        background: 'white',
        padding: 20,
        borderRadius: 6,
        boxShadow: '0 0 8px rgba(0,0,0,0.05)',
        marginBottom: 20,
    };

    const headerStyle = {
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem',
        flexWrap: 'wrap',
        marginBottom: '1rem',
        textTransform: 'uppercase',
    };

    // Se for vídeo YouTube
    if (arquivo.tipo === 5) {
        const embedUrl = getYoutubeEmbedUrl(arquivo.hashArquivo);
        if (!embedUrl) return <p style={{ textAlign: 'center' }}>URL de vídeo inválida.</p>;

        return (
            <div style={containerStyle}>
                <div style={headerStyle}>
                    <i className="bi bi-caret-right-fill menu-lateral-icon"></i>
                    <h4 style={{ margin: 0 }}>{arquivo.nomeArquivo}</h4>
                </div>
                <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0 }}>
                    <iframe
                        src={embedUrl}
                        title="Vídeo do YouTube"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            border: 'none',
                        }}
                    />
                </div>
            </div>
        );
    }

    // Se for link
    if (arquivo.tipo === 7) {
        return (
            <div style={containerStyle}>
                <div style={headerStyle}>
                    <i className="bi bi-caret-right-fill menu-lateral-icon"></i>
                    <h4 style={{ margin: 0 }}>{arquivo.nomeArquivo}</h4>
                </div>
                <div>
                    <a href={arquivo.hashArquivo} target="_blank" rel="noopener noreferrer">
                        {arquivo.nomeArquivo} <span style={{ fontSize: 12 }}>({arquivo.hashArquivo.substring(0, 50)})</span>
                    </a>
                </div>
            </div>
        );
    }

    // PDF
    if (isPDF) {
        return (
            <div style={containerStyle}>
                <div style={headerStyle}>
                    <i className="bi bi-caret-right-fill menu-lateral-icon"></i>
                    <h4 style={{ margin: 0 }}>{arquivo.nomeArquivo}</h4>
                </div>
                <iframe
                    src={`${baseURL}/${subpasta}/${arquivo.hashArquivo}`}
                    title="Visualizador PDF"
                    width="100%"
                    height="600px"
                    allowFullScreen
                    style={{ border: 'none' }}
                />
            </div>
        );
    }

    // Imagem
    return (
        <div style={containerStyle}>
            <div style={headerStyle}>
                <i className="bi bi-caret-right-fill menu-lateral-icon"></i>
                <h4 style={{ margin: 0 }}>{arquivo.nomeArquivo}</h4>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <img
                    src={`${baseURL}/${subpasta}/${arquivo.hashArquivo}`}
                    alt={arquivo.nomeArquivo || 'Arquivo de imagem'}
                    style={{
                        maxWidth: '100%',
                        maxHeight: '80vh',
                        objectFit: 'contain',
                        borderRadius: 6,
                        boxShadow: '0 0 8px rgba(0,0,0,0.1)',
                    }}
                />
            </div>
        </div>
    );
};

export default VisualizadorArquivo;
